// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"131":"33d9e12f","492":"dfbde9dc"}[chunkId] + ".chunk.css";
};